import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export const sequencePairs = [
  ['5', '7'], // sunrise & sunset
  ['11'], // fondue
  ['15'], // breakfast
  ['19'], // new year's
  ['23'], //advent
]

const getDefaultState = () => {
  return {
    currentLanguageCode: 'de',
    purchase_process: false,
    show_purchase_button: true,

    fahrttyp: 'ascent',

    eventSequence: null,

    selectedType: null,
    selectedDate: null,
    bergfahrt_EventDate_ID: null,
    talfahrt_EventDate_ID: null,
    subset_EventDate_ID: null,
    bergfahrt_Slot_ID: null,
    talfahrt_Slot_ID: null,
    subset_Slot_ID: null,
    bergfahrt_Slot_Time: '',
    talfahrt_Slot_Time: '',
    subset_Slot_Time: '',
    subset_Slot_Timestamp: '',
    total_Ticket_Sum: 0,

    fetch_GET_Content_Bergfahrt: null,
    fetch_GET_Content_Talfahrt: null,
    fetch_GET_Content_subset: null,
    fetch_GET_Tickets_Bergfahrt: [],
    fetch_GET_Tickets_Talfahrt: [],
    fetch_GET_Tickets_subset: [],

    edit_slots: [],
    edit_data: null,
    edit_date: null,

    fetch_GET_Tickets: [],
    fetch_GET_additionalProducts: [],
    fetch_GET_Tickets_Booking: [],
    fetch_GET_Configuration: {},

    booking_ID: '',
    booking_selectedDate: null,
    booking_bergfahrt_Slot_ID: null,
    booking_talfahrt_Slot_ID: null,
    booking_subset_Slot_ID: null,
    booking_bergfahrt_Slot_Reservation_ID: null,
    booking_talfahrt_Slot_Reservation_ID: null,
    booking_subset_Slot_Reservation_ID: null,

    ticket_reservation_amount: 0,
    reservation: [],
    reservation_ID: '',
    unassignedTickets: null,

    bergfahrt_Slot_Reservation: {},
    talfahrt_Slot_Reservation: {},
    subset_Slot_Reservation: {},

    customer: {
      firstName: '',
      lastName: '',
      email: '',
      emailRepeat: '',
      telephone: ''
    },
    comment: null,

    refresh: false,
    isLoading: false,
    isModal_InputActive: false,
    isModal_PricingActive: false,
    isModal_DeleteCurrentReservationActive: false,
    isModal_CustomMessageActive: false,
    customMessageModal_MessageTitle: '',
    customMessageModal_MessageSubTitle: '',

    checkout_link: null,

    iframeScript: null,

    error: {}
  }
}

export default new Vuex.Store({
  state: getDefaultState(),
  plugins: [createPersistedState({
    paths: [
      'purchase_process',
      'reservation_ID',
      'ticket_reservation_amount',
      'fetch_GET_Tickets',
      'fetch_GET_Tickets_Bergfahrt',
      'fetch_GET_Tickets_Talfahrt',
      'fetch_GET_Tickets_subset',
      'selectedType'
    ]
  })],
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState())
    },
    resetRunTimeState(state) {
      if (this.state.iframeScript) {
        // eslint-disable-next-line no-undef
        window.removeEventListener("message", Incert.processMessage);
        this.state.iframeScript.parentNode.removeChild(this.state.iframeScript);
        this.state.iframeScript = null;
        delete window["inc"];
        // eslint-disable-next-line no-undef
        Incert = undefined;
        // eslint-disable-next-line no-undef
        IncertClass = undefined;
        // eslint-disable-next-line no-undef
        incertIframe = undefined;
      }
      let new_state = getDefaultState();
      new_state.reservation_ID = this.state.reservation_ID;

      Object.assign(state, new_state);
    }
  },
  actions: {
    resetState({commit}) {
      commit('resetState')
    },
    resetRunTimeState({commit}) {
      commit('resetRunTimeState')
    }
  }
})
